<div class="card">
    <div class="card-body card-header-border">
        <div
            *ngIf="activeFocusesForPerformer.length > 0"
            class="text-center alert alert-primary w-100 active-focus-banner"
            (click)="activeFocusBannerClick.emit()"
        >
            {{
                _i18n._11092_THIS_USER_CURRENTLY_HAS_ACTIVE_COMMITMENTS
                    | translate
            }}
        </div>
        <div class="content">
            <div *ngIf="activeMetric?.id != null; else behaviourSelection">
                <p *ngIf="gridData?.rows && gridData.rows.length == 0">
                    {{
                        _i18n._11102_NO_CONFIGURED_FOCUSES_FOR_THIS_METRIC
                            | translate
                    }}
                </p>
                <reusable-grid
                    *ngIf="gridData?.rows && gridData.rows.length > 0"
                    [rendererOptions]="gridData.rendererOpts"
                    [selectTemplate]="_selectTpl"
                    [rowsTop]="gridData.gridRowsTop"
                    [rows]="gridData.rows"
                    [sortDefs]="gridData.sortDefs"
                    (selectRow)="_selectRow($event)"
                    selectType="single"
                    #grid
                >
                    <ng-template
                        gridContent
                        data-type="grid"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="row"
                        data-id="header"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="row"
                        data-id="content"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="cell"
                        data-id="header"
                        let-c="c"
                    >
                        <div>
                            <div>
                                <reusable-grid-sort
                                    [gridSortDef]="_getSortDef(c.id)"
                                    [column]="c"
                                    [isSorting]="
                                        gridData.sortDefs &&
                                        gridData.sortDefs.length &&
                                        gridData.sortDefs[0].columnId === c.id
                                    "
                                    (sortClick)="
                                        sortFocusSelectionGrid.emit($event)
                                    "
                                >
                                    {{ _getColumnTitle(c.id) }}
                                </reusable-grid-sort>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="cell"
                        data-id="content"
                        let-c="c"
                        let-l="l"
                        let-r="r"
                        let-ctx="ctx"
                    >
                        <div
                            [ngSwitch]="c.id"
                            [class.row-checked]="ctx.checked"
                            (click)="ctx.clickRow()"
                        >
                            <div
                                *ngSwitchCase="_ColumnID.RANK"
                                [class.justify-content-center]="
                                    ctx.isInExpandableRow
                                "
                                [class.justify-content-end]="
                                    !ctx.isInExpandableRow
                                "
                                class="rank-cell"
                            >
                                <cmps-icon
                                    *ngIf="ctx.isInExpandableRow && ctx?.medal"
                                    class="{{ 'medal ' + ctx.medal }}"
                                    svgIcon="medal"
                                    [cmpsTooltipTrigger]="
                                        (_i18n._777_RANK | translate) +
                                        ' ' +
                                        (ctx.rank ? ctx.rank.toString() : '')
                                    "
                                >
                                    >
                                </cmps-icon>
                                <reusable-grid-text
                                    *ngIf="ctx.isInExpandableRow"
                                    [text]="
                                        !ctx?.medal && ctx.rank
                                            ? ctx.rank.toString()
                                            : ''
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                >
                                </reusable-grid-text>
                                <cmps-checkbox
                                    *ngIf="!ctx.isInExpandableRow"
                                    [variant]="ctx.checkboxVariant"
                                    [checked]="ctx.checked"
                                    disabled
                                >
                                    <reusable-grid-text
                                        [text]="
                                            ctx.rank ? ctx.rank.toString() : ''
                                        "
                                        [resizeSubject]="ctx.resizeSubject"
                                    ></reusable-grid-text>
                                </cmps-checkbox>
                            </div>
                            <div
                                *ngSwitchCase="_ColumnID.FOCUS"
                                class="focus-cell"
                            >
                                <reusable-grid-text
                                    class="focus-name"
                                    [text]="ctx.focus | translate"
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                                <cmps-icon
                                    *ngIf="
                                        r?.context?.ctx?.cellContext
                                            ?.hasActiveCommitment
                                    "
                                    class="focus-icon"
                                    svgIcon="alert-box"
                                    [cmpsTooltipTrigger]="
                                        _i18n._11110_FOCUS_ALREADY_USED_IN_ACTIVE_COMMITMENT
                                            | translate
                                    "
                                ></cmps-icon>
                                <cmps-coaching-bl-button
                                    [focus]="
                                        r?.context?.ctx?.cellContext?.blFocus
                                    "
                                    *ngIf="
                                        r?.context?.ctx?.cellContext?.blFocus !=
                                        null
                                    "
                                ></cmps-coaching-bl-button>
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_15_DAY_IMPROVEMENT
                                "
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="
                                        ctx?.projected15 | cmpsPercent: '1.0-2'
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_30_DAY_IMPROVEMENT
                                "
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="
                                        ctx?.projected30 | cmpsPercent: '1.0-2'
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_60_DAY_IMPROVEMENT
                                "
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="
                                        ctx?.projected60 | cmpsPercent: '1.0-2'
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                        </div>
                    </ng-template>
                </reusable-grid>
            </div>
            <ng-template #behaviourSelection>
                <div class="row behaviour-selection">
                    <div class="col col-12 col-xl-6 behaviour-col">
                        <div>
                            <h5>{{ _i18n._7334_BEHAVIOUR | translate }}</h5>
                            <div class="radio-group-container">
                                <cmps-radio-group
                                    [value]="_selectedBehaviour?.id ?? ''"
                                >
                                    <cmps-radio
                                        *ngFor="let behaviour of behaviours"
                                        [attr.data-behaviourid]="behaviour.id"
                                        [value]="behaviour.id"
                                        (change)="
                                            _selectBehaviour(behaviour.id)
                                        "
                                    >
                                        {{ behaviour.name }}
                                    </cmps-radio>
                                </cmps-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-xl-6 subbehaviour-col">
                        <div *ngIf="_selectedBehaviour">
                            <h5>{{ _i18n._7307_TACTIC | translate }}</h5>
                            <div
                                *ngIf="
                                    _selectedBehaviour?.subBehaviours &&
                                        _selectedBehaviour.subBehaviours
                                            .length === 0;
                                    else subBehaviourList
                                "
                            >
                                {{
                                    _i18n._11094_THIS_BEHAVIOUR_HAS_NO_TACTICS
                                        | translate
                                }}
                            </div>
                            <ng-template #subBehaviourList>
                                <div class="radio-group-container">
                                    <cmps-radio-group
                                        [value]="
                                            _selectedSubBehaviour?.id ?? ''
                                        "
                                    >
                                        <cmps-radio
                                            *ngFor="
                                                let subBehaviour of _selectedBehaviour.subBehaviours
                                            "
                                            [attr.data-subBehaviourId]="
                                                subBehaviour.id
                                            "
                                            [value]="subBehaviour.id"
                                            (change)="
                                                _selectSubBehaviour(
                                                    subBehaviour.id
                                                )
                                            "
                                        >
                                            {{ subBehaviour.name }}
                                        </cmps-radio>
                                    </cmps-radio-group>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <div
        class="card-footer card-footer-search"
        *ngIf="!(activeMetric?.id != null && gridData.rows.length == 0)"
    >
        <button
            cmpsButton
            (click)="_selectFocus()"
            [disabled]="!_selectedBehaviour || !_selectedSubBehaviour"
        >
            <span cmpsButtonLabel>
                {{ _i18n._11103_SELECT_FOCUS | translate }}
            </span>
        </button>
        <ng-select
            [options]="_dropdownBehaviours"
            [ngModel]="_selectedBehaviour?.id ?? ''"
            (ngModelChange)="_selectBehaviour($event)"
            [placeholder]="_i18n._11093_FOCUS_SELECTION_PLACEHOLDER | translate"
            forceDropdownPosition
        >
        </ng-select>
    </div>
</div>

<!-- hack for when grid is the first to init the first cmps-coaching-bl-button, since grid needs explicit detectChanges() -->
<cmps-coaching-bl-button></cmps-coaching-bl-button>
